import { faLightbulb } from '@fortawesome/pro-solid-svg-icons';

import { Body, Icon, Tag } from '@growtherapy/sprout-ui';

import { ModifiedToastAria, Toast } from '../../toasts';

export function PromptFollowUpToast({
  title,
  subtitle,
  ...toastAriaProps
}: {
  title: string;
  subtitle: React.ReactNode;
} & ModifiedToastAria) {
  return (
    <Toast {...toastAriaProps} alignment='top' className='sm:max-w-sm'>
      <div className='flex gap-4 align-start flex-col'>
        <div className='flex justify-between'>
          <Tag use='lilac' className='flex flex-row justify-start items-center gap-2 px-2 py-1'>
            <Icon aria-hidden icon={faLightbulb} />
            <Body.Xsmall>{title}</Body.Xsmall>
          </Tag>
        </div>
        <Body.Small className='arc:text-text-inverse'>{subtitle}</Body.Small>
      </div>
    </Toast>
  );
}
